export default __webpack_public_path__ + "static/media/Mutual-aid.a6fedc31.jpg";